import styles from './Section.module.css'

/**
 * Section grouping with title, optional description, and optional action.
 */
export function Section({ title, description, action, children, className = '' }) {
  return (
    <section className={`${styles.section} ${className}`}>
      {(title || action) && (
        <div className={styles.header}>
          <div>
            {title && <h3 className={styles.title}>{title}</h3>}
            {description && <p className={styles.description}>{description}</p>}
          </div>
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      {children}
    </section>
  )
}
